<template>
	<div>
		<keep-alive :include="keepAliveInclude">
			<router-view></router-view>
		</keep-alive>
	</div>
</template>

<script>
import { ref } from "vue";
export default {
	setup() {
		return {
			keepAliveInclude: ref(["financeManage"]),
		};
	},
};
</script>

<style scoped>
</style>
